var PageNote = require('../pgNote');



module.exports = PageNote.extend({
    init: 'T',
    desc: 'Page Text Note',
    createHotKey: 't',
    actionTitle: 'Page Text Note',
    iconClass: 'icm-type',
    autoDisplayApplies: false,
    isText: true, // flag determining if doc/pg note if a 'text note'
    consultsApplicable: false, // could apply to non drawable note types, but I think we only care about drawable ones here; a change would necessitate change in the slop note ui

    /**
     * DVBC-1299: currently auto display has no meaning for page text notes DV,
     * ( it only means showing the shapes of drawable notes ).
     * But leave this here is cause it ever does.  Unlike drawable notes, a value of null ( new notes )
     * or 'V' ( existing notes ) implies that autoDisplay should apply ( if there's ever a need ).
     */
    applyAutoDisplay: function() {

        var noteStatus = this.get('noteStatus');
        return noteStatus === null || noteStatus === 'V';

    }


});


/*****************
 ** WEBPACK FOOTER
 ** ./assets/js/modules/notes/models/page/noteTypes/text.js
 ** module id = 285
 ** module chunks = 0
 **/